import Layer from './Layer';

const MORIOKA_LAYERS = {
    // 盛岡防災マップ レイヤー構成
    // 浸水深 = 重ねるハザードマップでは「洪水浸水想定区域（想定最大規模）」
    // 氾濫流によって家屋倒壊等の危険 = 重ねるハザードマップでは「家屋倒壊棟氾濫想定区域（氾濫流）」
    // 河岸侵食によって家屋倒壊等の危険 = 重ねるハザードマップでは「家屋倒壊棟氾濫想定区域（河岸浸食）」
    // 早期の立退き避難が必要 = 重ねるハザードマップでは表示なし。「家屋倒壊棟氾濫想定区域（氾濫流）」と「家屋倒壊棟氾濫想定区域（河岸浸食）」をORした領域。
    'flood-house-10-line': { 'source-layer': 'house', code: '10', type: 'line', minzoom: 9, isFilter: true, },  // 早期の立退き避難が必要
    'flood-house-12-line': { 'source-layer': 'house', code: '12', type: 'line', minzoom: 9, isFilter: true, },  // 河岸侵食によって家屋倒壊等の危険
    'flood-house-11-line': { 'source-layer': 'house', code: '11', type: 'line', minzoom: 9, isFilter: true, },  // 氾濫流によって家屋倒壊等の危険
    'flood-house-10-fill': { 'source-layer': 'house', code: '10', type: 'fill', minzoom: 9, isFilter: true, isClickable: true },    // 早期の立退き避難が必要 ※ tooltip 用で透明
    'flood-house-12-fill': { 'source-layer': 'house', code: '12', type: 'fill', minzoom: 9, isFilter: true, isClickable: true },    // 河岸侵食によって家屋倒壊等の危険 ※ tooltip 用で透明
    'flood-house-11-fill': { 'source-layer': 'house', code: '11', type: 'fill', minzoom: 9, isFilter: true, isClickable: true },    // 氾濫流によって家屋倒壊等の危険
    'flood-l2': { 'source-layer': 'flood-l2', type: 'fill', minzoom: 5, isClickable: true }, // 浸水深
};

const DEFAULT_OPACITY = 0.75;

// ハザードマップ
export default class FloodInundationHazardMap extends Layer {
    url = process.env.REACT_APP_FLOODINUNDATIONHAZARDMAP_URL;

    popup = null;

    constructor() {
        const id = 'hazardMap';

        const layers = {};
        for (const key in MORIOKA_LAYERS) {
            const layer = MORIOKA_LAYERS[key];
            if (layer.isFilter) {
                layers[key] = {
                    type: layer.type,
                    source: id,
                    'source-layer': layer['source-layer'],
                    filter: ["==", 'code', layer.code],
                    minzoom: layer.minzoom
                };
            } else {
                layers[key] = {
                    type: layer.type,
                    source: id,
                    'source-layer': layer['source-layer'],
                    minzoom: layer.minzoom
                };
            }
        }

        const paintOptions = {
            // 浸水深
            "flood-l2": {
                "fill-opacity": DEFAULT_OPACITY,
                "fill-color": {
                    type: "categorical",
                    property: "A31_201",
                    stops: [
                        [1, "rgb(247, 245, 169)"],
                        [2, "rgb(255, 216, 192)"],
                        [3, "rgb(255, 183, 183)"],
                        [4, "rgb(255, 145, 145)"],
                        [5, "rgb(242, 133, 201)"],
                        [6, "rgb(220, 122, 220)"]
                    ]
                },
                "fill-outline-color": "rgba(0, 0, 0, 0)"
            },

            "flood-house": {
                "fill-opacity": 0.0
            },

            // 氾濫流によって家屋倒壊等の危険
            "flood-house-11-fill": {
                "fill-pattern": "wide-upward-diagonal-green"
            },
            "flood-house-11-line": {
                "line-color": "#256A2B",
                "line-width": 2,
                "line-offset": 1
            },

            // 河岸侵食によって家屋倒壊等の危険
            "flood-house-12-fill": {
                "fill-opacity": 0.0
            },
            "flood-house-12-line": {
                "line-color": "#E85E19",
                "line-width": 2,
                "line-offset": 2,
                "line-dasharray": [1, 1]
            },

            // 早期の立退き避難が必要
            "flood-house-10-fill": {
                "fill-opacity": 0.0
            },
            "flood-house-10-line": {
                "line-color": "#D6003D",
                "line-width": {
                    stops: [
                        [10, 1],
                        [13, 2]
                    ]
                },
                "line-offset": -0.5
            },
        };

        // レイヤー要素。この単位でレイヤリングする。配列順に最前面→再後面
        const elements = [
            { id: 'house-3', layers: ['flood-house-10-fill', 'flood-house-10-line'], isShow: true },  // 早期の立退き避難が必要
            { id: 'house-2', layers: ['flood-house-12-fill', 'flood-house-12-line'], isShow: true },  // 河岸侵食によって家屋倒壊等の危険
            { id: 'house-1', layers: ['flood-house-11-fill', 'flood-house-11-line'], isShow: true },  // 氾濫流によって家屋倒壊等の危険
            { id: 'flood', layers: ['flood-l2'], isShow: true },  // 浸水深
        ];

        super(id, layers, paintOptions, elements);
    }

    // レイヤーは時刻を持たないのでオーバーライドして null 値をセットする。
    set datetime(datetime) { super.datetime = null; }
    get datetime() { return super.datetime; }

    onClick(e) {
        const layers = [...Object.keys(MORIOKA_LAYERS).filter(x => MORIOKA_LAYERS[x].isClickable)];
        const features = this.map.queryRenderedFeatures(e.point, {
            layers: layers,
        });

        if (!features.length) {
            return;
        }

        const content = [];

        const A31_201 = {
            1: '0.5m未満',
            2: '0.5〜3.0m',
            3: '3.0〜5.0m',
            4: '5.0〜10.0m',
            5: '10.0〜20.0m',
            6: '20.0m以上'
        };
        const l2 = features.filter(f => f.layer.id === 'flood-l2')[0];
        if (l2) {
            const depth = A31_201[l2.properties.A31_201];
            content.push('想定最大浸水深: ' + depth);
        }

        const house = features.filter(f => ['flood-house-10-fill', 'flood-house-11-fill', 'flood-house-12-fill'].includes(f.layer.id));
        const houseCodes = house.map(f => f.properties.code);
        if (houseCodes.length) {
            if (houseCodes.includes('10')) content.push('早期の立退き避難が必要');
            if (houseCodes.includes('11')) content.push('氾濫流によって家屋倒壊等の危険');
            if (houseCodes.includes('12')) content.push('河岸侵食によって家屋倒壊等の危険');
        }

        return '洪水浸水ハザードマップ<ul>' + content.map(x => `<li>${x}</li>`).join('') + '</ul>';
    }

    async add() {
        this.map.addSource(this.id, {
            type: "vector",
            minzoom: 0,
            maxzoom: 13,
            tiles: [this.url],
            attribution:
                '「岩手県洪水浸水想定区域GISデータ」を加工して作成 | <a href="https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-A31-v2_1.html" target="_blank">「国土数値情報（洪水浸水想定区域データ）」を加工して作成</a>',
        });

        this._elements
            .forEach(element => {
                element.layers.forEach(id => {
                    this.map.addLayer({
                        id: id
                        , ...this.layers[id]
                        , layout: { visibility: (element.isShow ? 'visible' : 'none') }
                        , paint: { ...this._paintOptions[id] }
                    });
                });
            });
    }

    remove() {
        Object.keys(this.layers)
            .map(x => this.map.removeLayer(x));

        this.map.removeSource(this.id);
    }

    showElement(element, isShow) {
        this._elements
            .filter(x => (x.id === element))
            .forEach(x => {
                x.layers.forEach(id =>
                    this.map.setLayoutProperty(id, 'visibility', isShow ? 'visible' : 'none')
                );
                x.isShow = isShow;
            });
    }
};


